export default {
      id: "bullet-list-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite-46b249.svg#bullet-list-usage",
      toString: function () {
        return this.url;
      }
    }